module.exports = __webpack_public_path__ + "img/position_icon.ca19d110.svg";